import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

var gqlGetAssetChecks = gql`
  query getChecks($organizationId: UUID!, $assetId: UUID!) {
    assetImagesReady(assetId: $assetId, organizationId: $organizationId)
    assetPricingReady(assetId: $assetId, organizationId: $organizationId)
    assetContractTemplatesReady(assetId: $assetId, organizationId: $organizationId)
    assetReservationReady(assetId: $assetId, organizationId: $organizationId)
  }
`;

export function apiGetAssetChecks(organizationId, assetId) {

    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        client
            .query({
                query: gqlGetAssetChecks,
                variables: {organizationId, assetId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get asset checks");
                reject(err); // R
            })
    });
}
